const navigationType =
  typeof performance === 'undefined'
    ? ''
    : (performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined)?.type || ''

const initialPath =
  typeof window === 'undefined' ? '' : window.location.hash.slice(1).split('?')[0].replace(/\/$/, '') || '/'

const resetPaths = new Set<string>()

export function shouldResetPaginationAfterRefresh(path: string) {
  const normalizedPath = path.replace(/\/$/, '') || '/'
  if (navigationType !== 'reload' || normalizedPath !== initialPath || resetPaths.has(normalizedPath)) return false

  resetPaths.add(normalizedPath)
  return true
}
